export const stripCurrency = (value: any) => {
  const text = Array.isArray(value) ? value.join("") : String(value ?? "");
  return text.replace("R$", "").trim();
};
